import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";

import { TableRow, Button } from "@material-ui/core";

import { getErrorMessage } from "src/util/errors";

import { ControlsCell, MappingCell, NameCell } from "./CalleeFieldTableRow";
import CsvColumnSelect from "./CsvColumnSelect";
import NameInput from "./NameInput";
import SaveFieldButton from "./SaveFieldButton";
import UnsavedChangeAlert from "./UnsavedChangeAlert";

export default function NewCalleeFieldTableRow({
  dataSourceFieldNames,
  onSubmit,
  onDirty,
  highlightUnsavedChanges,
  dataSourceFieldLabel
}: {
  dataSourceFieldNames: string[];
  onSubmit: (name: string, dataSourceFieldName: string | null) => any;
  onDirty?: (dirty: boolean) => any;
  highlightUnsavedChanges?: boolean;
  dataSourceFieldLabel: string;
}): JSX.Element {
  const [isAddingField, toggleIsAddingField] = useState(false);
  const [name, setName] = useState<string>("");
  const [dataSourceFieldName, setDataSourceFieldName] = useState<string | null>(
    null
  );

  useEffect(() => onDirty && onDirty(isAddingField), [isAddingField, onDirty]);

  const snackbar = useSnackbar();

  const closeNewField = () => {
    toggleIsAddingField(false);
    setName("");
    setDataSourceFieldName(null);
  };

  const handleSubmit = async () => {
    if (!name.length) {
      return;
    }

    try {
      await onSubmit(name, dataSourceFieldName);
      closeNewField();
    } catch (e) {
      snackbar.enqueueSnackbar(`Error adding field: ${getErrorMessage(e)}`, {
        variant: "error"
      });
    }
  };

  return isAddingField ? (
    <>
      {highlightUnsavedChanges ? <UnsavedChangeAlert /> : null}
      <TableRow>
        <ControlsCell>
          <SaveFieldButton onClick={handleSubmit} disabled={!name.length} />
          <Button onClick={closeNewField}>Cancel</Button>
        </ControlsCell>
        <NameCell>
          {/* TODO: use form */}
          <NameInput value={name} onChange={setName} />
        </NameCell>
        <MappingCell>
          <CsvColumnSelect
            id="new-callee-field"
            value={dataSourceFieldName}
            onChange={setDataSourceFieldName}
            options={dataSourceFieldNames}
            dataSourceFieldLabel={dataSourceFieldLabel}
          />
        </MappingCell>
      </TableRow>
    </>
  ) : (
    <TableRow>
      <ControlsCell>
        <Button onClick={() => toggleIsAddingField(true)}>+ Add</Button>
      </ControlsCell>
      <NameCell />
      <MappingCell />
    </TableRow>
  );
}
